import React from "react";
import LookupManagerPage from "./LookupManagerPage";

function GrantsPage() {
  return (
    <LookupManagerPage
      title="Grants"
      endpoint="/grants"
      createPath="/grants/new"
      editPathBase="/grants"
      fields={[
        { name: "name", label: "Name" },
        { name: "description", label: "Description", type: "textarea", required: false }
      ]}
    />
  );
}

export default GrantsPage;
